import { useTranslate } from "@similarweb/i18n-provider";

import manageIntegrationsTrackingService from "app/pages/sales-intelligence/modules/manage-integrations/services/tracking";
import managementTrackingService from "app/pages/sales-intelligence/modules/management/services/tracking/managementTrackingService";
import { MANAGEMENT_COMMON_CONNECT } from "app/pages/sales-intelligence/pages/management/translations/managementKeys";
import siNavigator from "app/pages/sales-intelligence/services/siNavigator";

import IntegrationButtonWrapperWithFeatureRequest from "app/pages/sales-intelligence/modules/manage-integrations/components/integration-button/IntegrationButtonWrapperWithFeatureRequest";
import { StyledManagementCardButton } from "../../components/cards-components/styles";
import useFindNewCompaniesData from "../../hooks/useFindNewCompaniesData";

const FindNewCompaniesGatewayButtonContainer = (): React.ReactElement => {
    const { translate } = useTranslate();

    const { hasAccess, isEnabled } = useFindNewCompaniesData();

    const handleConnectClick = () => {
        manageIntegrationsTrackingService.trackGatewayConnect("findNewCompaniesWebhook");
        void siNavigator.goToManagementSavedSearchWebhooksPage();
    };

    const handleUpgradeClick = () => {
        managementTrackingService.trackSignalApiHook("find new company/upgrade");
    };

    return (
        <IntegrationButtonWrapperWithFeatureRequest
            hookId="FindNewCompaniesWebhook"
            dataAutomationNameSpace="find-new-companies"
            featureName="findNewCompaniesWebhook"
            upgradeButtonText={translate("si.common.contact_us")}
            hasAccess={hasAccess}
            isEnabled={isEnabled}
            onUpgradeClick={handleUpgradeClick}
        >
            <StyledManagementCardButton
                buttonHtmlType="button"
                type="primary"
                onClick={handleConnectClick}
                data-automation="find-new-companies.gateway-connect-button"
            >
                {translate(MANAGEMENT_COMMON_CONNECT)}
            </StyledManagementCardButton>
        </IntegrationButtonWrapperWithFeatureRequest>
    );
};

export default FindNewCompaniesGatewayButtonContainer;
